
export const CSSClassNames = {

    overrideHover: "hover-override",
    blockEditor: "block-edit",
    


}